export const Constants = {
  POST_CODE_REGEXP: new RegExp("^[0-9]{3}-[0-9]{4}$"),
  TEL_REGEXP: new RegExp("^[0-9-]*$"),
  ONE_LINE_TEXT_MAX: 255,
  MULTI_LINE_TEXT_MAX: 10000,

  USER_STATUS: { VALID: "VALID" },
  TABLES: { PROCEDURE: "t_procedure" },
  MESSAGE_TYPE: { PROCEDURE_INFO: "PROCEDURE_INFO" },
  TOOL_BAR_MESSAGE_TYPE: {
    INFO: "INFO",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    WARNING: "WARNING",
  },
  MESSAGE_CLASSIFICATION: { REQUEST: "REQUEST", RESPONSE: "RESPONSE" },
  PROCECURE_STATUS: {
    REGISTERED: "REGISTERED",
    WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
    APPROVED: "APPROVED",
    STARTED: "STARTED",
    CLOSED: "CLOSED",
  },
  CONFIRMATION_LETTER_STATUS: {
    REGISTERED: "REGISTERED",
    WAITING_FOR_SHIPMENT: "WAITING_FOR_SHIPMENT",
    SHIPPED: "SHIPPED",
    APPROVAL_REQUEST_REMANDED_BY_CONFIRMER:
      "APPROVAL_REQUEST_REMANDED_BY_CONFIRMER",
    WAITING_FOR_APPROVAL_OF_CONFIRMER: "WAITING_FOR_APPROVAL_OF_CONFIRMER",
    RESPONSED: "RESPONSED",
    EXCLUDED: "EXCLUDED",
  },

  ROLE: {
    AUDITOR: "auditor",
    CLIENT: "client",
    CONFIRMER: "confirmer",
    ADMIN: "admin",
  },

  APPROVAL_TYPE: { ALL_APPROVER: "ALL_APPROVER" },

  CONFIRMATION_LETTER_TYPE: {
    OWNED_STOCK: "OWNED_STOCK",
    RECEIVABLE_PAYABLE: "RECEIVABLE_PAYABLE",
  },

  CLIENT_AUTHORITY_TYPE: {
    EDIT: "EDIT",
    APPROVAL: "APPROVAL",
    EDIT_APPROVAL: "EDIT_APPROVAL",
    READ: "READ",
  },
  CONFIRMER_AUTHORITY_TYPE: {
    EDIT: "EDIT",
    APPROVAL: "APPROVAL",
    EDIT_APPROVAL: "EDIT_APPROVAL",
    APPROVER: "APPROVER",
    APPROVAL_REQUESTER: "APPROVAL_REQUESTER",
  },

  SENDING_METHOD: {
    EMAIL_OR_POST: "EMAIL_OR_POST",
    POST: "POST",
  },

  OWNED_STOCK_KUBUN: {
    OWNED_STOCK: "OWNED_STOCK",
    EQUITY: "EQUITY",
    CORPORATE_BOND: "CORPORATE_BOND",
    STOCK_ACQUISITION_RIGHTS: "STOCK_ACQUISITION_RIGHTS",
    OTHER_STOCK: "OTHER_STOCK",
  },

  CONFIRMER_ACTIONS: {
    INPUT_REQUEST: "INPUT_REQUEST",
    APPROVAL_REQUEST: "APPROVAL_REQUEST",
    SUBMIT_RESPONSE: "SUBMIT_RESPONSE",
  },

  MAIL_MESSAGE: {
    OWNED_STOCK: {
      SUBJECT: "【ご対応のお願い】#{被監査企業} 所有株式等確認のお願い",
      TEXT: [
        "#{相手先名称}",
        "#{宛名}",
        "",
        "平素よりお世話になっております。 ",
        "#{被監査企業}の会計監査に関連し、HLB Meisei有限責任監査法人より、当社の貴社に対する所有株式等の確認について、ご対応をお願い申し上げます。",
        "お手数をおかけいたしますが、当社の記録による下記内容が貴社の記録と相違ないことをご確認いただき、#{回収希望日}までに確認状システムを通じて、HLB Meisei有限責任監査法人宛にご回答くださいますようお願い申し上げます。 ",
        "もし、下記の内容に相違がある場合は、システム内の「相違内容」フォームにご入力いただきますようお願い申し上げます。",
        "なお、本確認依頼は、貴社への支払督促ではございませんので、念のため申し添えます。",
        "",
        "【確認内容】",
        "基準日：#{基準日}",
        "確認状管理番号：#{リファー番号}",
        "確認方法：以下のリンクからアクセスし、ご確認ください。",
        "※パスワードの入力を求められた場合は、マイクロソフトアカウントのパスワードを使用してください。",
        "#{URL}",
        "",
      ].join("\n"),
    },
    RECEIVABLE_PAYABLE: {
      SUBJECT: "【ご対応のお願い】#{被監査企業} 債権債務ご確認のお願い",
      TEXT: [
        "#{相手先名称}",
        "#{宛名}",
        "",
        "平素よりお世話になっております。 ",
        "#{被監査企業}の会計監査に関連し、HLB Meisei有限責任監査法人より、当社の貴社に対する債権債務の確認について、ご対応をお願い申し上げます。",
        "お手数をおかけいたしますが、当社の記録による下記内容が貴社の記録と相違ないことをご確認いただき、#{回収希望日}までに確認状システムを通じて、HLB Meisei有限責任監査法人宛にご回答くださいますようお願い申し上げます。 ",
        "もし、下記の内容に相違がある場合は、システム内の「相違内容」フォームにご入力いただきますようお願い申し上げます。",
        "なお、本確認依頼は、貴社への支払督促ではございませんので、念のため申し添えます。",
        "",
        "【確認内容】",
        "基準日：#{基準日}",
        "確認状管理番号：#{リファー番号}",
        "確認方法：以下のリンクからアクセスし、ご確認ください。",
        "※パスワードの入力を求められた場合は、マイクロソフトアカウントのパスワードを使用してください。",
        "#{URL}",
        "",
      ].join("\n"),
    },
  },
};

export default Constants;
